import { createContext, memo, ReactNode, useState } from "react";
import { PlaceOnHoldModal } from "./place-on-hold-modal";

export const PlaceOnHoldModalContext = createContext<
  (fulfillmentGroupIds: string[]) => void
>(() => {});

export const PlaceOnHoldModalProvider = memo(function PlaceOnHoldModalProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [fulfillmentGroupIds, setFulfillmentGroupIds] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  const openModalWithGroups = (newFulfillmentGroupIds: string[]) => {
    setFulfillmentGroupIds(newFulfillmentGroupIds);
    setOpen(true);
  };

  return (
    <PlaceOnHoldModalContext.Provider value={openModalWithGroups}>
      {children}
      {fulfillmentGroupIds.length > 0 && (
        <PlaceOnHoldModal
          closeModal={() => setOpen(false)}
          fulfillmentGroupIds={fulfillmentGroupIds}
          isOpen={open}
        />
      )}
    </PlaceOnHoldModalContext.Provider>
  );
});
